<template>
    <div v-if="isVisible" class="popup-container">
        <div class="card white popup">
            <h2>Transfert du CIL {{ property?.name }}</h2>
            <p>Êtes-vous sûr de vouloir transférer ce CIL ?<br />
                Tous vos documents seront transmis, vous n'y aurez plus accès.
            </p>
            <div class="form-control">
                <label for="email">Email*</label>
                <input type="email" id="email" v-model="email" />
            </div>
            <div class="form-control">
                <label for="confirmationText">Recopiez TRANSFERT pour confirmer*</label>
                <input type="text" id="confirmationText" v-model="confirmationText" placeholder="TRANSFERT" />
            </div>
            <div class="popup-actions">
                <button class="button fill orange" @click="transfertCil"
                    :disabled="isSending || confirmationText !== 'TRANSFERT'">
                    Transférer
                </button>
                <button class="button outline orange" @click="cancelAction" :disabled="isSending">
                    Annuler
                </button>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        isVisible: Boolean,
        property: {},
    },
    data() {
        return {
            email: "",
            confirmationText: "",
            isSending: false,
        };
    },
    methods: {
        cancelAction() {
            this.email = "";
            this.confirmationText = "";
            this.$emit("cancel");
        },
        async transfertCil() {
            if (this.confirmationText !== "TRANSFERT") return;
            if (this.email === "") return;

            this.isSending = true;

            try {
                const response = await fetch(process.env.VUE_APP_API_URL + 'logements/transfert', {
                    method: 'POST',
                    credentials: 'include',
                    headers: { 'Content-Type': 'application/json' },
                    body: JSON.stringify({ propID: this.property.ID, email: this.email })
                });
                const data = await response.json();
                if (data.error) return alert(data.error);

                this.$emit("confirm");
            } catch (error) {
                alert("Erreur lors du transfert");
                console.error("Erreur lors du transfert", error);
            } finally {
                this.isSending = false;
                this.email = "";
                this.confirmationText = "";
            }
        }
    },
};
</script>
